import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedMenu: null,
};

const lockedCampaignSlice = createSlice({
  name: "locked_campaign_slice",
  initialState,
  reducers: {
    setSelectedMenu: (state, action) => {
      state.selectedMenu = action.payload;
    },
    resetLockedCampaignSlice: () => {
      return initialState;
    },
  },
});

export const { setSelectedMenu, resetLockedCampaignSlice } =
  lockedCampaignSlice.actions;

export default lockedCampaignSlice.reducer;
